module.exports = __webpack_public_path__ + "media/application/images/svgs/gitlab-c498a32614f630d72ca32b2b00b1128c.svg";